module.exports = __webpack_public_path__ + "static/media/a1.33dbb1b6.jpg";